import axios from 'axios';

export const BASE_URL = process.env.NODE_ENV === 'development'
  ? process.env.REACT_APP_API_DEV_BASE_URL
  : process.env.REACT_APP_API_PROD_BASE_URL;

export const apiInstance = axios.create({
  baseURL: BASE_URL
});
